import { render, staticRenderFns } from "./buyingrules.vue?vue&type=template&id=5e4c2d20&"
import script from "./buyingrules.vue?vue&type=script&lang=js&"
export * from "./buyingrules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports